<template>
  <v-data-table
    :items="sellers"
    :headers="productDataHeader"
    hide-default-footer
    hide-default-header
    item-key="seller_name"
    class="ex-data-table"
    >
      <template v-slot:header="{ props: { headers } }">
        <thead>
        <tr>
          <th v-for="(h, h_index) in headers" :key="`${h_index}-${h.value}-${productUrlId}`" :class="h.class">
            <span>{{h.text}}</span>
          </th>
        </tr>
        </thead>
      </template>
      <template v-slot:item="{item, index}">
        <tr class="product_row_title">
          <td>
            <div class="product_row_cell">
              <div
                :style="{
                  background: item['color_code'] ? item['color_code'] : 'unset',
                  color: item['color_code'] ? item['color_code'] : 'transparent'
                }"
                class="variation_color">&nbsp;
              </div>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ item.seller_name || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell" style="max-width:250px;">
                 <v-select
                :items="variations"
                item-text="value"
                item-value="id"
                v-on:change="changeVariation($event, item)"
                label=""
                single-line
                color="#fff"
                :value="item.variation_id"
                full-width
                outlined
                dense
              ></v-select>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getPrice(item['tracks_properties'])['property_value'] || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getPrice(item['tracks_properties'])['renewed'] || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getAvailability(item['tracks_properties'])['property_value'] || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getAvailability(item['tracks_properties'])['renewed'] || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getShipping(item['tracks_properties'])['property_value'] || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ getShipping(item['tracks_properties'])['renewed'] || '_' }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ item.created_at.date }}
              </span>
            </div>
          </td>
          <td>
            <div class="product_row_cell">
              <span class="ex-data-table__link">
                {{ item.created_from }}
              </span>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
</template>

<script>

export default {
  name: 'N_SellersDetails',
  props: {
    sellers: {
      type: [Object, Array],
      default: null
    },
    productUrlId: {
      type: Number,
      default: null,
      required: true
    }
  },
  data: () => ({
    productDataHeader: [
      {
        text: '#',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'index'
      },
      {
        text: 'Seller',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'seller'
      },
      {
        text: 'Variation',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'variation_text'
      },
      {
        text: 'Price',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'price'
      },
      {
        text: 'Renewed',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'renewed'
      },
      {
        text: 'Availability',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'availability'
      },
      {
        text: 'Renewed',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'renewed2'
      },
      {
        text: 'Shipping',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'shipping'
      },
      {
        text: 'Renewed',
        align: 'left',
        sortable: false,
        class: 'tableHeaderClass',
        value: 'renewed2'
      },
      {
        text: 'Created_at',
        align: 'left',
        sortable: true,
        class: 'tableHeaderClass',
        value: 'created_at.date'
      },
      {
        text: 'Created_from',
        align: 'left',
        sortable: true,
        class: 'tableHeaderClass',
        value: 'created_at.date'
      }
    ]
  }),
  computed: {
    variations () {
      return this.$store.state.productionModule.variations
    }
  },
  methods: {
    getPrice: properties => properties.find((property) => property['property_id'] === 5) || {
      property_value: '',
      renewed: ''
    },
    getAvailability: properties => properties.find((property) => property['property_id'] === 8) || {
      property_value: '',
      renewed: ''
    },
    getShipping: properties => properties.find((property) => property['property_id'] === 9) || {
      property_value: '',
      renewed: ''
    },
    changeVariation (variationId, item) {
      let data = { variation_id: variationId, track_id: item.track_id }
      this.$store.dispatch('productionModule/UPDATE_SELLER_VARIATION', data)
    }
  }
}
</script>

<style scoped>
.total-product-data-table table > tbody > tr > td {
  padding-top: 15px !important;
}
.v-expansion-panel-header {
  padding: 16px 14px;
}
.product_row_cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
}

table tr td {
  position: relative;
}

.variation_color {
  width: 20px;
  height: 20px;
  margin: 0;
  border-radius: 5px;
}

.tableHeaderClass span{
  font-weight: 300;
  color: #9899ac;
  font-size: 14px;
  display: block;
  margin-top: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/production/N_SellerDetails.vue